import React from 'react';
import UserDataForm from '@/components/UserDataForm';
import PageTransition from '@/components/PageTransition';
import { usePageTitle } from '@/hooks/usePageTitle';

const Questionnaire = () => {
  usePageTitle('Questionnaire');

  return (
    <PageTransition>
      <div className="w-full flex flex-col items-center justify-start px-4 pt-8 pb-24">
        <UserDataForm />
      </div>
    </PageTransition>
  );
};

export default Questionnaire; 